import { WATCHLIST_ID } from '@terminal/config/constants';
import { createPublicListEntitiesQueryOptions } from '@terminal/react-query-hooks/usePublicLists';
import { queryClient } from '@terminal/services/query-client/queryClient';
import type { SelectedAssetItem } from '@terminal/views/dashboard/calendar-widget/calendar-event-drawer/drawer-content/run-scenario/RunScenario';
import { ConditionOptions } from '@terminal/views/dashboard/calendar-widget/calendar-event-drawer/drawer-content/utils/getConditionOptions';
import { ConditionWithLabel } from '@terminal/widgets/scenario/components/scenario-assistant-modal/use-scenario-assistant/useScenarioAssistant';
import { getScreenerEntitiesTagsQueryConfig } from '@terminal/widgets/scenario/hooks/use-screener-entities-tags/useScreenerEntitiesTags';

export const createCustomCondition = (
  conditionOptions: ConditionOptions,
  entity: string,
  actualUnit?: string
): ConditionWithLabel => {
  const {
    value,
    config: { snake, condition, value: configValue },
  } = conditionOptions;

  return {
    entity: entity.toLowerCase(),
    snake,
    condition,
    value: configValue,
    label: value,
    actualUnit: actualUnit ?? '',
  };
};

export const resolveSelectedAssetEntityTags = async (
  selectedAssets: SelectedAssetItem
) => {
  if (selectedAssets.assetFilterValueKey === WATCHLIST_ID) {
    // Use the same API as useScreenerEntitiesTags to preserve asset ordering.
    const { enabled, ...screenerEntitiesTagsQuery } =
      getScreenerEntitiesTagsQueryConfig({
        filterOptions: [
          {
            id: selectedAssets.id,
            filter: 'entity_tag',
            options: [
              {
                key: selectedAssets.id,
                name: selectedAssets.id,
                value: { [WATCHLIST_ID]: selectedAssets.id },
              },
            ],
          },
        ],
      });

    if (!enabled) {
      return [];
    }

    const watchlist = await queryClient.query({
      ...screenerEntitiesTagsQuery,
      staleTime: 'static',
    });

    return watchlist.entities;
  }

  const list = await queryClient.query({
    ...createPublicListEntitiesQueryOptions(selectedAssets.id),
    staleTime: 'static',
  });

  return list.entities.map(entity => entity.tag);
};
